module.exports = __webpack_public_path__ + "media/images/emblems/Truttikon-blazon-009dd3857fe70699b97d65c7e4688707.svg";